import { Component } from 'preact';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Utils
import { actionHandler } from '../../../utilities/form/formUtils';
import { toggleSwitchAction } from '../../../utilities/Steps/stepsUtils';
// Components
import Text from '../../Global/Text';
import Label from '../../Form/Label';
import Description from '../../Form/Description';
import Error from '../../Form/Error';

class ToggleSwitch extends Component {
  constructor(props) {
    super(props);
    this.onInput = this.onInput.bind(this);
    const {
      values,
      id,
      variant,
      defaultValue,
      hidden,
      activeState,
    } = this.props;
    this.state = {
      isLink: variant === 'link',
      active: activeState || false,
    };

    if ((Object.hasOwnProperty.call(values, id) && values[id])
      || (hidden && defaultValue)) {
      this.state = {
        ...this.state,
        active: true,
      };
    }
  }

  onInput(event) {
    const {
      actions,
      dispatch,
      onChange,
      values,
      setValues,
    } = this.props;
    const { active, isLink } = this.state;
    const newActive = !active
    this.setState(prevState => {
      return { active: !prevState.active };
    });

    const actionValue = actions && actions.length > 0 ?
      toggleSwitchAction(actions, values, newActive) : actions;
    // If isLink then the action should be fired on the label, and not the checkbox
    if (!isLink && actionValue && actionValue.length > 0) {
      actionHandler(actionValue, onChange, event, dispatch, values, setValues);
    } else {
      onChange(event);
    }
  }

  handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      const changeEvent = new Event("change");
      const inputElement = e.target.querySelector("input.form__item");
      if (inputElement) {
        inputElement.checked = !this.state.active;
        inputElement.dispatchEvent(changeEvent);
      }
    }
  };

  render() {
    const {
      actions,
      dispatch,
      id,
      name,
      label,
      onBlur,
      desc,
      descMore,
      required,
      touched,
      errors,
      hidden,
      className,
      formColumns,
      labelActions,
      activeText,
      disableMsg,
      values,
      setValues,
    } = this.props;
    const { active } = this.state;
    const nameAssigned = !name ? id : name;
    this.props.name = nameAssigned;
    const formElementClass = classNames(
      'form__field form__field--toggle form__field--checkbox float--left', {
        'hidden': hidden,
        [`${className}`]: className,
        [`form__field--${formColumns}col`]: formColumns,
      }
    );
    const formLabelClass = classNames(
      'float--right', {
        'hidden': hidden,
      [`${className}`]: className,
      [`form__field--${formColumns}col`]: formColumns,
      }
    );
    const labelProps = {
      actions: labelActions,
      dispatch,
      values,
      setValues,
    };
    const switchClass = active ? 'form--border form--border-active' : 'form--border';
    return (
      <div className={switchClass}>
        <div
          className={formElementClass}
          tabIndex={0}
          onKeyDown={this.handleKeyDown}
        >
          {activeText && active && (
            <span className="float--left display__text--light display__text--small padding__top--xxsmall">
              <em>{activeText}</em>
            </span>
          )}

          {/* Error Message */}
          <Error touched={touched} errors={errors} id={id} />

          {disableMsg &&
            <span className="float--right display__text--light display__text--small"><em><Text value={disableMsg} /></em></span>
          }

          {/* Input Field */}
          {!disableMsg &&
            <span className="float--left">
              <input
                className='form__item'
                type="checkbox"
                id={id}
                name={nameAssigned}
                value={id}
                required={required}
                onBlur={onBlur}
                checked={active}
                onChange={e => this.onInput(e)}
                aria-checked={active}
                role="checkbox"
                aria-label="nameAssigned"
              />

              {/* Label */}
              {label &&
                <Label
                  id={id}
                  label=' '
                  actions={actions}
                  dispatch={dispatch}
                  values={values}
                  setValues={setValues}
                  tabIndex={-1}
                />
              }

              {/* Description */}
              {desc &&
                <Description desc={desc} more={descMore} />
              }
            </span>
          }
        </div>
        <div className={formLabelClass}>
          {/* Label */}
          {label &&
            <Label
              label={label}
              {...labelProps}
              tabIndex={-1}
            />
          }
        </div>
      </div>
    );
  }
}

export default ToggleSwitch;

ToggleSwitch.defaultProps = {
  actions: null,
  label: null,
  desc: null,
  variant: null,
  required: false,
  name: null,
  descMore: null,
  hidden: false,
  defaultValue: false,
  className: 'form--switch',
  formColumns: '5',
  labelActions: null,
  activeText: 'Tilvalgt',
  disableMsg: '',
  activeState: false,
};

ToggleSwitch.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  actions: PropTypes.array,
  variant: PropTypes.string,
  label: PropTypes.string,
  desc: PropTypes.string,
  required: PropTypes.bool,
  setValues: PropTypes.func.isRequired,
  name: PropTypes.string,
  descMore: PropTypes.object,
  hidden: PropTypes.bool,
  defaultValue: PropTypes.bool,
  className: PropTypes.string,
  formColumns: PropTypes.string,
  labelActions: PropTypes.object,
  activeText: PropTypes.string,
  activeState: PropTypes.bool,
  disableMsg: PropTypes.string,
};
